import React from "react";
import { Images } from "lucide-react";
import { useVehicles } from "@/hooks/useVehicles";

const AdminMedia: React.FC = () => {
  const { vehicles, loading } = useVehicles();
  const images = vehicles.flatMap((vehicle) => vehicle.images.map((src, index) => ({
    src,
    label: vehicle.fullTitle,
    key: `${vehicle.databaseId}-${index}`,
  })));

  return <div className="space-y-6">
    <div><p className="text-[11px] font-bold uppercase tracking-[0.22em] text-slate-400">Library</p><h1 className="text-2xl font-extrabold text-slate-900">Vehicle Media</h1><p className="mt-1 text-sm text-slate-500">All images attached to inventory records. Add and remove images from each vehicle’s edit page.</p></div>
    <div className="card-soft p-5"><h2 className="flex items-center gap-2 text-lg font-bold text-slate-900"><Images className="h-5 w-5 text-blue-600" /> Media Library ({images.length})</h2>{loading ? <p className="py-10 text-center text-slate-400">Loading images...</p> : <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">{images.map((image) => <div key={image.key} className="group relative overflow-hidden rounded-xl ring-1 ring-slate-100"><img src={image.src} alt={image.label} loading="lazy" className="h-28 w-full object-cover" /><div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-900/80 to-transparent p-2 pt-8"><span className="block truncate text-[11px] font-semibold text-white">{image.label}</span></div></div>)}</div>}</div>
  </div>;
};

export default AdminMedia;
